import { createHttpActions } from '@next/arable-lib/shared';

import { createAction } from '@ngrx/store';

import { EnvironmentalImpactDelivery, EnvironmentalImpactWithBenchmark } from '../environmental-impact.models';

export const [
  loadEnvironmentalImpactWithBenchmark,
  loadEnvironmentalImpactWithBenchmarkSuccess,
  loadEnvironmentalImpactWithBenchmarkFailed,
] = createHttpActions<
  { cropFieldId: number },
  { report: EnvironmentalImpactWithBenchmark },
  { message: string }
>('Load Environmental Impact With Benchmark')

export const loadEnvironmentalImpactWithBenchmarkNotFound = createAction('Load Environmental Impact With Benchmark Not Found');

export const [
  loadEnvironmentalImpactDeliveriesCurrentYear,
  loadEnvironmentalImpactDeliveriesCurrentYearSuccess,
  loadEnvironmentalImpactDeliveriesCurrentYearFailed,
] = createHttpActions<
  void,
  { deliveries: EnvironmentalImpactDelivery },
  { message: string }
>('Load Environmental Impact Deliveries Current Year');

export const [
  loadEnvironmentalImpactDeliveriesLastYear,
  loadEnvironmentalImpactDeliveriesLastYearSuccess,
  loadEnvironmentalImpactDeliveriesLastYearFailed,
] = createHttpActions<
  void,
  { deliveries: EnvironmentalImpactDelivery },
  { message: string }
>('Load Environmental Impact Deliveries Request Last Year');
